var dinner = [
    {
        "id": "13",
        "name": "Baked Chicken Fry",
        "category": "dinner",
        "img": "https://i.imgur.com/b50xqHV.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 9.99
    },
    {
        "id": "14",
        "name": "Lemoni Selmon Piccata",
        "category": "dinner",
        "img": "https://i.imgur.com/O0I2Rvi.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 10.99
    },
    {
        "id": "15",
        "name": "Garlic Butter Baked Salmons",
        "category": "dinner",
        "img": "https://i.imgur.com/YNtu9XA.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 6.99
    },
    {
        "id": "16",
        "name": "Pork Tenderloin With Quinoa",
        "category": "dinner",
        "img": "https://i.imgur.com/E6SndU9.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 8.99
    },
    {
        "id": "17",
        "name": "Beef Tendiro Grapefruit",
        "category": "dinner",
        "img": "https://i.imgur.com/Uv5Z39E.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 12.99
    },
    {
        "id": "18",
        "name": "Salmon with Green salad",
        "category": "dinner",
        "img": "https://i.imgur.com/NnNC2Jj.png",
        "description": "how we dream about our future",
        "story": "Food is any substance consumed to provide nutritional support for an organism. Food is usually of plant or animal origin, and contains essential nutrients, such as carbohydrates, fats, proteins, vitamins, or minerals.",
        "price": 9.99
    },


]
export default dinner;